export default "__VITE_ASSET__BKOhd8Cx__"